import { useState, useMemo, useEffect, useRef } from 'react';
import '../../../assets/css/StudentDashboard.css'

import { useNavigate } from 'react-router-dom';
import { getBlob, getData, UpdateDataForm } from '../../../API/GlobalApi.js';

import { FilterContestant } from '../../../Component/Filter/FilterContestant.jsx';
import { useTableFade } from '../../../Utils/tableFadeHooks.js';
import Notifier from '../../../Utils/notify.js';
import AdvanceTable from '../../../Utils/AdvanceTables.js';
import TableSkeleton from '../../../Utils/TableSkeleton.js';
import SpinnerLoader from '../../../Utils/Spinner.js';
import SearchingBar from '../../../Utils/Searching.js';
import TableLoaderOverlay from '../../../Utils/tableFadingLoader.js';
import exporticon from '../../../assets/icons/export-data.svg';
import { UploadContestData } from '../../../Component/Modals/UploadContestDatas.js';
import { copyToClipboard } from '../../../Utils/copyToClipboard.js';
import edit from '../../../assets/icons/editnew.svg';
import { v4 as uuidv4 } from 'uuid';
import Select from "react-select";
import { reactSelectStyles } from '../../../Utils/selectBoxStyle.js';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { formatDateDDMMYYYY, formatLocalDate } from '../../../Utils/data&dateTime.js';
import { ShowSchoolNames } from './ShowSchoolName.js';

export const ContestReport = () => {

    const [contestantParticipants, setContestantParticipants] = useState([])
    const [selectedParticipants, setselectedParticipants] = useState([]);
    const [filterContestant, setFilterContestant] = useState([])
    const pageSize = 10;
    const [currentPage, setCurrentPage] = useState(0); // Starts from 0
    const [totalCount, setTotalCount] = useState(0);
    const pageCounts = Math.ceil(totalCount / pageSize);
    const { skipSpinnerRef, tableLoading, triggerTableLoading, stopTableLoading } = useTableFade();
    const [isLoading, setIsLoading] = useState(true);
    const [isSearchLoading, setSearchLoading] = useState(false);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [filterQueryString, setFilterQueryString] = useState({});
    const [filtermodal, setfiltermodal] = useState(false);
    const [exportmodal, setExportmodal] = useState(false);
    const handleFilterClick = () => {
        // onFilter(searchQuery); 
        setfiltermodal(true);
    };

    const handlePageChange = ({ selected }) => {
        triggerTableLoading();
        setCurrentPage(selected);
    };
    // const [fromDate, setFromDate] = useState('');
    // const [toDate, setToDate] = useState('');

    const [isSearching, setIsSearching] = useState(false);
    // const [sortField, setSortField] = useState(null);
    // const [sortOrder, setSortOrder] = useState(null);
    const [searchValue, setSearchValue] = useState("");
    const [isSearchMode, setIsSearchMode] = useState(false);
    const [selectedStudent, setselectedStudent] = useState([]);
    const [filterLoading, setFilterLoading] = useState(false)
    // At the top of your component
    // const [backgroundLoading, setBackgroundLoading] = useState(false);
    const [openDataUpload, setOpenDataUpload] = useState(false)
    // const isFirstLoadRef = useRef(true);
    // const searchValueRef = useRef("");
    // useEffect(() => {
    //     searchValueRef.current = searchValue;
    // }, [searchValue]);
    const [reportDataCounts, setReportDataCounts] = useState({
        total_credit: 0,
        total_debit: 0,

    });
    const [refreshKey, setRefreshKey] = useState(0);

    const getContestDatas = async (
        page = 0,
        filters = filterQueryString,
    ) => {
        const pageNumber = page + 1;
        const queryParams = new URLSearchParams({
            ...filters,
            page: pageNumber,
        });
        queryParams.set("page", pageNumber);
        const url = `administration/contest-report/?${queryParams.toString()}`;

        if (!skipSpinnerRef.current) {
            if (isInitialLoad) setIsLoading(true);
            else setSearchLoading(true);
        }
        try {
            const res = await getData(url);
            console.log("Responsese in repots", res)
            if (res?.report) {
                const results = res?.report?.results;
                setContestantParticipants(results)
                setTotalCount(res?.report.count || 0)
                setFilterContestant(results)
                // ✅ store counts separately
                const total_credit = res.total_credit || 0;
                const total_debit = res.total_debit || 0;

                setReportDataCounts({
                    total_credit: total_credit,
                    total_debit: total_debit,

                });
            }

            // Auto-select first student
            if (res.results?.length > 0) {
                setselectedParticipants(res.results[0]);
            } else {
                setselectedParticipants(null); // clear previous selection
            }
            // ✅ Mark first load done here
            // if (isFirstLoadRef.current) isFirstLoadRef.current = false;
            return res;
        } catch (err) {
            Notifier.error(err);
            setContestantParticipants([]);
            setTotalCount(0);
            return null;
        } finally {
            if (!skipSpinnerRef.current) {
                if (isInitialLoad) {
                    setIsLoading(false);
                    setIsInitialLoad(false);
                } else {
                    setSearchLoading(false);
                }
                setFilterLoading(false);
            }

            skipSpinnerRef.current = false;

            setFilterLoading(false);
        }
    };

    useEffect(() => {
        if (isSearching && refreshKey === 0) return;
        getContestDatas(
            currentPage,
            filterQueryString,
        ).finally(() => stopTableLoading());

    }, [currentPage, filterQueryString, refreshKey]);

    const typeOptions = [
        { label: "Online", value: 0 },
        { label: "Offline", value: 1 },
    ];


    const [selectedStatus, setSelectedStatus] = useState(null);              // pending or completed

    const [collegeOptions, setCollegeOptions] = useState([]);
    const [selectedCollege, setSelectedCollege] = useState(null);
    const getCollegeList = async () => {
        const res = await getData('administration/get-college-list/2/');
        if (res?.colleges) {
            const options = res.colleges.map(college => ({ value: college, label: college }));
            setCollegeOptions(options);
        }
    };

    const [dateRange, setDateRange] = useState([
        {
            startDate: null,
            endDate: null,
            key: 'selection',
        },
    ]);
    const formatDate = (date) => date.toISOString().split("T")[0];
    const [showCalendar, setShowCalendar] = useState(false);
    const isSelectingEndRef = useRef(false);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!e.target.closest('.date-range-wrapper')) {
                setShowCalendar(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);





    const [sourceOptions, setSourceOptions] = useState([]);
    const [source, setSource] = useState(null);

    const getSources = async () => {
        const res = await getData("administration/contest-sources/");

        if (!res?.error) {
            const options = res.map((item) => ({
                value: item.id,     // ✅ backend-safe
                label: item.name,   // ✅ UI-friendly
            }));
            setSourceOptions(options);
        }
    };




    useEffect(() => {
        getCollegeList();
        getSources()
    }, []);

    const navigate = useNavigate();
    const handleRowClick = (orgId, row) => {
        setselectedParticipants(row.original);
    };



    const [openEditContestDetails, setOpenEditContestDetails] = useState(false)

    const handleEditClick = (id, row) => {
        setOpenEditContestDetails(true)
        setselectedParticipants(row?.original)

    }
    const [showCollegeNameModal, setShowCollegeNameModal] = useState(false)

    const handleReadMore = (row) => {
        setselectedParticipants(row.original); // pass row to modal
        setShowCollegeNameModal(true); // open modal
    };



    const columns = useMemo(
        () => [
            // {
            //     Header: <input type='checkbox' />,
            //     accessor: 'checkbox',
            //     Cell: ({ row }) => (
            //         <input type="checkbox" checked={row.isSelected} onChange={() => row.toggleRowSelected()}
            //             style={{ cursor: 'pointer' }} />
            //     ),
            // },

            // {
            //     Header: "Date",
            //     disableSortBy: true,
            //     accessor: 'date',
            //     Cell: ({ row }) => (
            //         <div
            //             style={{ cursor: 'pointer' }}
            //             onClick={() => handleRowClick(row.original.id, row)}>
            //             <p
            //                 style={{
            //                     textAlign: 'left',
            //                     color: '#222F3E',
            //                     fontWeight: 500,
            //                     margin: 0,
            //                     cursor: 'pointer',
            //                     // textDecoration: 'underline'
            //                 }}
            //             // title="Copy Form Number"
            //             // onClick={(e) => {
            //             //     e.stopPropagation(); // ✅ prevent row click
            //             //     copyToClipboard(
            //             //         row.original.arct_roll_number,
            //             //         "Form number copied"
            //             //     );
            //             // }}
            //             >
            //                 {formatDateDDMMYYYY(row.original.date)}
            //             </p>
            //         </div>
            //     ),
            // },
            {
                Header: "Particular",
                disableSortBy: true,
                accessor: "name",
                Cell: ({ row }) => {
                    const source = row?.original?.contest_sources;
                    const previousInstitutions = row?.original?.previous_institutions || "";

                    // split institutions by comma
                    const institutions = previousInstitutions
                        .split(",")
                        .map(i => i.trim())
                        .filter(Boolean);

                    const firstInstitution = institutions[0] || "";
                    const remainingCount = institutions.length - 1;

                    return (
                        <div className="no-text-cursor">
                            <p
                                style={{
                                    textAlign: "left",
                                    color: "#222F3E",
                                    fontWeight: 500,
                                    margin: 0,
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                    fontSize: "13px",
                                }}
                            >
                                {/* ✅ First institution */}
                                {previousInstitutions}

                                {/* ✅ Remaining count */}
                                {/* {remainingCount > 0 && (
                                    <span
                                        style={{
                                            marginLeft: "6px",
                                            color: "#7F56DA",
                                            fontWeight: 'bold',
                                            cursor: "pointer",
                                            fontSize: "14px",
                                            // textDecoration: "underline",
                                        }}
                                        title='More School names'
                                        onClick={() => handleReadMore(row)}
                                    >
                                        ... +{remainingCount}
                                    </span>
                                )} */}

                                <br />

                                <span style={{ marginLeft: "5px", color: "#7F56DA", fontWeight: 500 }}>
                                    {source ? `Source (${source})` : "Source (NA)"}
                                </span>
                            </p>
                        </div>
                    );
                },
            },
            {
                Header: "Mode",
                disableSortBy: true,
                accessor: "type",
                Cell: ({ row }) => {
                    const online = Number(row.original.online_count) ?? 0;
                    const offline = Number(row.original.offline_count) ?? 0;

                    const chipBase = {
                        display: "inline-block",
                        padding: "2px 10px",
                        borderRadius: "12px",
                        color: "#fff",
                        fontWeight: 500,
                        fontSize: "12px",
                        textAlign: "center",
                        minWidth: "90px",
                    };

                    const showOnline = online > 0 || (online === 0 && offline === 0);
                    const showOffline = offline > 0 || (online === 0 && offline === 0);

                    return (
                        <div style={{ display: "flex", gap: "6px", justifyContent: "flex-start" }} className="no-text-cursor" >
                            {showOnline && (
                                <span
                                    style={{
                                        ...chipBase,
                                        backgroundColor: "#4CAF50",
                                    }}
                                >
                                    Online ({online})
                                </span>
                            )}

                            {showOffline && (
                                <span
                                    style={{
                                        ...chipBase,
                                        backgroundColor: "#F44336",
                                    }}
                                >
                                    Offline ({offline})
                                </span>
                            )}
                        </div>
                    );
                },
            },
            {
                Header: () => (
                    <div style={{ textAlign: 'right' }}>
                        Registered </div>
                ),
                accessor: 'offline_count',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div className="no-text-cursor">
                        <p style={{ textAlign: 'right', color: '#222F3E', fontWeight: 500, margin: 0 }}>
                            {row.original.offline_count + row.original.online_count || 0}
                        </p>
                        {/* <p style={{ textAlign: 'left', margin: 0 }}>{row.original.permanent_registration_number ? row.original.permanent_registration_number : '-'}</p> */}
                    </div>
                ),
            },
            {
                Header: () => (
                    <div style={{ textAlign: 'right' }}>
                        Exam
                    </div>
                ),
                disableSortBy: true,
                accessor: 'completed_count',
                Cell: ({ row }) => (
                    <div
                        style={{ cursor: 'pointer' }} className="no-text-cursor"
                    >
                        <p style={{ textAlign: 'right', color: '#222F3E', fontWeight: 500, margin: 0 }}>
                            {row.original.completed_count || 0}
                        </p>

                    </div>
                ),
            },
            {
                Header: () => (
                    <div style={{ textAlign: 'right' }}>
                        Balance   </div>
                ),
                disableSortBy: true,
                accessor: 'balance',
                Cell: ({ row }) => (
                    <div className="no-text-cursor">
                        <p style={{ textAlign: 'right', color: '#222F3E', margin: 0 }}>{row.original.balance || 0}</p>
                    </div>
                )
            },

        ],
        []
    );


    // Dynamically choose data source
    const sourceData = useMemo(() => {
        return filterQueryString
            ? filterContestant
            : contestantParticipants;
    }, [contestantParticipants, filterContestant, filterQueryString]);


    const formattedData = useMemo(() => {
        return sourceData?.map((emp) => {
            const offline = Number(emp.offline_count) || 0;
            const online = Number(emp.online_count) || 0;
            const completed = Number(emp.completed_count) || 0;

            return {
                id: uuidv4(),
                date: emp.date,
                type: emp.type || '',
                offline_count: offline,
                online_count: online,
                completed_count: completed,
                balance: offline + online - completed, // ✅ CALCULATED HERE
                contest_sources: emp.contest_sources || '',
                previous_institutions: emp.institute || 'NA',
                handleRowClick,
            };
        }) || [];
    }, [sourceData]);


    const searchInputRef = useRef(null);

    useEffect(() => {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, []);

    // const modalOpenQueryRef = useRef({
    //     page: 0,
    //     query: '',
    //     sortField: sortField,
    //     sortOrder: sortOrder,
    // });

    const handleExportExcel = async () => {
        // onFilter(searchQuery); 
        setExportmodal(true);
        try {
            const urlWithParams = 'administration/contest-report-excel/'
            const blob = await getBlob(urlWithParams);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'Contest_report_export.xlsx';
            document.body.appendChild(a);
            a.click();
            a.remove();
        } catch (error) {
            Notifier.error('❌ Excel export failed', 'danger');
        }
    };

    const handleSetSearchResults = (data) => {
        console.log("Data", data)
        let results = [];
        let count = 0;

        if (Array.isArray(data)) {
            results = data;
            count = data.length;
        } else if (data?.results) {
            results = data.results;
            count = data.count || data.results.length;
        }
        setFilterContestant(results);
        if (results.length > 0) {
            const stillExists = selectedStudent
                ? results.find(x => x.id === selectedStudent.id)
                : null;

            setselectedStudent(stillExists || results[0]);
        } else {
            setselectedStudent(null);
        }
    };

    const handleSearchValueChange = (value) => {
        setSearchValue(value);
        if (!value.trim()) {
            setFilterQueryString((prev) => {
                if (!prev || typeof prev !== 'object') return {};
                const { search, ...rest } = prev;
                return rest;
            });
            setIsSearchMode(false);
            setIsSearching(false);
            setCurrentPage(0);
        } else {
            // Add search key to existing filter
            setFilterQueryString((prev) => ({
                ...(prev || {}),
                search: value.trim(),
            }));
            setIsSearchMode(true);
            setIsSearching(true);
            setCurrentPage(0);
        }
    };

    const handleSort = (columnId, order) => {
        console.log("columnid", columnId)
        console.log("order", order)
        setFilterLoading(true);
        setCurrentPage(0);

        setFilterQueryString(prev => ({
            ...prev,
            sort_by: order === "asc" ? columnId : `-${columnId}`,
        }));

        setRefreshKey(prev => prev + 1);
    };


return (
    <>
        {isLoading ? (
            <TableSkeleton rows={10} columns={6} showHeader={true} />
        ) : (
            <div style={{
                display: "flex",
                flexDirection: "column",
                height: "100vh",
                overflow: "hidden",
                position: "relative",
            }}>

                {/* ── FIXED: Title + Stats Card ── */}
                <div style={{ flexShrink: 0, padding: "0 12px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <h2 className="main-heading">Contest Report</h2>
                        <div style={{ width: "400px" }}>
                            <div className="p-3 rounded shadow-sm"
                                style={{ background: "#fff", borderLeft: "4px solid #7F56DA" }}>
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <h6 className="m-0" style={{ fontWeight: 600 }}>Report Status</h6>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span style={{ color: "#22C55E" }}>
                                        <strong>Registered:</strong> {reportDataCounts.total_credit}
                                    </span>
                                    <span style={{ color: "green" }}>
                                        <strong>Exam:</strong> {reportDataCounts.total_debit}
                                    </span>
                                    <span>
                                        <strong>Balance:</strong> {reportDataCounts.total_credit - reportDataCounts.total_debit}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ── FIXED: Filters ── */}
                <div style={{ flexShrink: 0, padding: "8px 12px" }}>
                    <div className="d-flex justify-content-end gap-2 flex-wrap">
                        <div style={{ width: "250px" }}>
                            <Select
                                options={typeOptions}
                                value={selectedStatus}
                                onChange={(option) => {
                                    setSelectedStatus(option);
                                    setFilterLoading(true);
                                    setFilterQueryString(prev => {
                                        const updated = { ...prev };
                                        if (option) { updated.offline = option.value; }
                                        else { delete updated.offline; }
                                        return updated;
                                    });
                                    setCurrentPage(0);
                                    setRefreshKey(prev => prev + 1);
                                }}
                                isClearable
                                placeholder="Mode"
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={reactSelectStyles}
                            />
                        </div>
                        <div style={{ width: "250px" }}>
                            <Select
                                options={sourceOptions}
                                value={source}
                                onChange={(option) => {
                                    setSource(option);
                                    setFilterLoading(true);
                                    setFilterQueryString(prev => {
                                        const updated = { ...prev };
                                        if (option) { updated.source = option.value; }
                                        else { delete updated.source; }
                                        return updated;
                                    });
                                    setCurrentPage(0);
                                    setRefreshKey(prev => prev + 1);
                                }}
                                placeholder="Select Source"
                                isClearable
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={reactSelectStyles}
                            />
                        </div>
                        <div style={{ width: "250px" }}>
                            <Select
                                options={collegeOptions}
                                value={selectedCollege}
                                onChange={(option) => {
                                    setSelectedCollege(option);
                                    setFilterLoading(true);
                                    setFilterQueryString(prev => {
                                        const updated = { ...prev };
                                        if (option) { updated.institute = option.value; }
                                        else { delete updated.institute; }
                                        return updated;
                                    });
                                    setCurrentPage(0);
                                    setRefreshKey(prev => prev + 1);
                                }}
                                isClearable
                                placeholder="College Name"
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={reactSelectStyles}
                            />
                        </div>
                        <button
                            className="filter-btns"
                            style={{ background: "white", border: "1px solid #7F56DA", height: "43px" }}
                            onClick={handleExportExcel}
                            title="Export data"
                        >
                            <img src={exporticon} alt="export" />
                        </button>
                    </div>
                </div>

                {/* ── SCROLLABLE: Table only ── */}
                <div style={{
                    flex: 1,
                    minHeight: 0,
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                    padding: "0 12px",
                }}>
                    {filterLoading ? (
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flex: 1 }}>
                            <SpinnerLoader />
                        </div>
                    ) : formattedData?.length > 0 ? (
                        <AdvanceTable
                            columns={columns}
                            pageCounts={pageCounts}
                            handlePageChange={handlePageChange}
                            selectedData={selectedStudent}
                            data={formattedData}
                            handleRowClick={handleRowClick}
                            currentPage={currentPage}
                            checkbox={false}
                            handleSort={handleSort}
                        />
                    ) : (!isLoading && !isSearchLoading && (
                        <div style={{
                            display: "flex", flexDirection: "column",
                            alignItems: "center", justifyContent: "center",
                            flex: 1, color: "#888", textAlign: "center",
                        }}>
                            No Students Found.
                        </div>
                    ))}
                </div>

                <TableLoaderOverlay isLoading={tableLoading} />
            </div>
        )}

        {showCollegeNameModal && selectedParticipants && (
            <ShowSchoolNames
                isOpen={showCollegeNameModal}
                onClose={() => setShowCollegeNameModal(false)}
                selectedParticipants={selectedParticipants}
            />
        )}
    </>
);
};


export default ContestReport